module.exports = function() {
  return new Worker(__webpack_public_path__ + "61447231c5546cf73bbc.worker.js");
};